import React from 'react';
import useUiStateStore from '../../_store/useUiStateStore';
import formDefaultData from '../../_constants/formDefaultData';

const NotiPopup = (props) => {
    const { resetFormValues } = props;
    const { isSubmitOkPopupOpen, setSubmitOkPopupOpen, setRegistPopupOpen } = useUiStateStore();
    
    const okBtnClick = () => {
        resetFormValues();
        setSubmitOkPopupOpen(false);
        setRegistPopupOpen(false);
    }

    return (
        <>
            {isSubmitOkPopupOpen ? (
                <>
                    <div className="card-content">
                        <ul className="card-content-list">
                            <li className='popup-noti'> 
                                <div className="title-area popup-noti">
                                    <div>
                                        <strong>알림</strong>
                                    </div>
                                </div>

                                <div className="desc-area popup-noti">
                                    <div className="contents-section-title">
                                        <span className="popup-noti">이용권 신청이 완료되었습니다.<br/>카카오톡으로 이용권 코드를 보내드려요.</span>
                                    </div>
                                </div>

                                <div className="btn-container">
                                    <button type="button" className="btn-basic">
                                        <span className="inquireMessage" onClick={() => okBtnClick()}>확인</span>
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className={`modal-dim show popup-noti`}></div>
                </>
            ) : (
                <>
                </>
            )}
        </>
    )
}

export default NotiPopup
